<template>
  <div>
    <div class="anmeldung">
      <div class="form_wrapper">
        <img src="../assets/fve_logo.png">
        <h3>FV Egenhausen – Besucherregistrierung</h3>
        <div class="unended_visits" v-if="unended_visits.length != 0">
          <h4>Aktueller Besuch</h4>
          <ul>
            <li v-for="item in unended_visits" :key="item.id">
              <v-row
                justify="space-between"
              >
                <span>{{item.area}} | {{item.date}}</span>
                <v-btn
                        depressed
                        color="primary"
                        :loading="loading"
                        :disabled="loading"
                        @click="end_visit(item.id)"
                >
                  Beenden
                </v-btn>
              </v-row>

            </li>
          </ul>
        </div>


        <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                autocomplete="on"
        >
          <v-select
                  v-model="select"
                  :items="items"
                  :rules="[v => !!v || 'Bitte Auswahl treffen']"
                  label="Wofür möchten Sie sich registrieren?"
                  required
                  @click="resetValidation"
          ></v-select>
          <v-text-field
                  v-model="vorname"
                  :rules="vornameRules"
                  label="Vorname"
                  required
                  @click="resetValidation"
          ></v-text-field>
          <v-text-field
                  v-model="nachname"
                  :rules="nachnameRules"
                  label="Nachname"
                  required
                  @click="resetValidation"
          ></v-text-field>
          <v-text-field
                  v-model="telefonnummer"
                  :rules="telefonRules"
                  label="Telefonnummer"
                  type="number"
                  required
                  @click="resetValidation"
          ></v-text-field>
          <v-text-field
                  v-model="anzahlPersonen"
                  :rules="anzahlRules"
                  label="Anzahl Begleitpersonen aus eigenem Haushalt"
                  type="number"
                  required
                  @click="resetValidation"
          ></v-text-field>
          <v-checkbox
                  v-model="checkbox"
                  label="Angaben für nächsten Besuch speichern"
          ></v-checkbox>
          <div class="submit_holder">
            <div class="submit_button_wrapper">
              <v-btn
                      block
                      :disabled="!valid || loading"
                      :loading="loading"
                      color="primary"
                      class="mr-4 submit_button"
                      @click="validate"
              >
                Registrieren
              </v-btn>
            </div>
          </div>

        </v-form>
        <p><strong>Datenschutz</strong><br>Die angegebenen Daten werden vertraulich behandelt und lediglich für die gegebenenfalls nötige Nachverfolgung von Infektionsketten im Zusammenhang mit der Corona-Pandemie verwendet. Rechtsgrundlage sind erlassene Verordnungen und Bestimmungen zur aktuellen Corona-Pandemie. Die erhobenen Daten werden vier Wochen aufbewahrt und ausschließlich auf Anforderung der zuständigen Behörden weitergegeben. Als betroffene Person haben Sie im Hinblick auf Ihre erhobenen personenbezogenen Daten das Recht auf Auskunft, Berichtigung, sowie nach Ablauf der Aufbewahrungspflicht das Recht auf Löschung Ihrer Daten. Hierzu können Sie sich gerne an uns wenden: FV Egenhausen, An den Kastanien 1, 97440 Werneck, kontakt@fvegenhausen.de</p>
      </div>
    </div>
    <v-dialog
            v-model="dialog"
            width="500"
    >
      <v-card>
        <v-card-title class="headline primary">
          <span style="color: #fff">Vielen Dank!</span>
        </v-card-title>

        <v-card-text>
          <p style="margin-top: 16px; font-size: 18px;">Ihren gestarteten Besuch sehen sie in der Übersicht wenn Sie diese Nachricht schließen. Dort können Sie den Besuch auch wieder beenden.</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
                  color="primary"
                  text
                  @click="dialog = false"
          >
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
            v-model="snackbar"
            top
    >
      {{ snackbartext }}
    </v-snackbar>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
export default {
  name: 'Form',
  data: () => ({
    loading: false,
    checkbox: true,
    dialog: false,
    anzahlPersonen: 0,
    telefonnummer: '',
    valid: true,
    vorname: '',
    nachname: '',
    snackbar: false,
    snackbartext: "",
    unended_visits: [],
    vornameRules: [
      v => !!v || 'Bitte Vorname angeben'
    ],
    nachnameRules: [
      v => !!v || 'Bitte Nachname angeben'
    ],
    anzahlRules: [
      v => (!isNaN(parseFloat(v)) && v >= 0 && v <= 10) || 'Bitte geben Sie an wie viele Personen aus Ihrem Haushalt Sie begleiten (0-10 Personen möglich)'
    ],
    telefonRules: [
      v => !!v || 'Bitte Telefonnummer angeben'
    ],
    select: null,
    items: [
      'Gaststätte',
      'Sportgelände'
    ]
  }),

  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },
    validate () {
      let valid = this.$refs.form.validate();
      if(valid) {
        this.loading = true;
        var storage_data = {};
        storage_data['area']= this.select;
        storage_data['fname'] =  this.vorname;
        storage_data['sname'] = this.nachname;
        storage_data['telephone'] = this.telefonnummer;
        storage_data['persons'] = this.anzahlPersonen;

        if(this.checkbox) {
          localStorage.setItem("fve_guest_register_data", JSON.stringify(storage_data));
        } else {
          localStorage.removeItem("fve_guest_register_data");
        }
        const params = {
          area: this.select,
          fname: this.vorname,
          sname: this.nachname,
          telephone: this.telefonnummer,
          persons: parseInt(this.anzahlPersonen) + 1
        };
        axios.post('/api/guest_2_db.php', params, {
          headers: {
            'content-type': 'application/json'
          }
        }).then((response) => {
          if(response.data.status) {
            let guest_id = response.data.id;
            this.handle_unended_visits(guest_id, this.select);
            this.show_success();
            this.scrollToTop();
          } else {
            this.snackbartext = "Die Registrierung hat leider nicht funktioniert";
            this.snackbar = true;
            console.log(response);
          }
          this.loading = false
        })
        .catch((error) => {
          console.error(error);
          this.snackbartext = "Die Registrierung hat leider nicht funktioniert";
          this.snackbar = true;
          this.loading = false
        });
      }
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    handle_unended_visits(new_visit_id, area) {
      if(new_visit_id) {
        var new_unended_visit = {};
        new_unended_visit.id = new_visit_id;
        new_unended_visit.area = area;
        new_unended_visit.date = moment().format("DD.MM.YYYY HH:mm");
        this.unended_visits = [];
        this.unended_visits.push(new_unended_visit);
        localStorage.setItem("fve_unended_visits", JSON.stringify(this.unended_visits));
      } else {
        let unended_visits = localStorage.getItem("fve_unended_visits");
        if(unended_visits && unended_visits != "") {
          unended_visits = JSON.parse(unended_visits);
          if(unended_visits.length != 0) {
            let id = unended_visits[0].id;
            if(id) {
              const params = {
                visit_id: id
              };
              axios.post('/api/is_visit_open.php', params, {
                headers: {
                  'content-type': 'application/json'
                }
              }).then((response) => {
                if(response.data.status) {
                  if(response.data.ended == null) {
                    this.unended_visits = unended_visits;
                  } else {
                    localStorage.removeItem("fve_unended_visits");
                  }
                }
              });
            }
          }
        }
      }
    },
    show_success() {
      this.dialog = true;
    },
    end_visit(id) {
      this.loading = true
      const params = {
        visit_id: id
      };
      axios.post('/api/guest_2_db.php', params, {
        headers: {
          'content-type': 'application/json'
        }
      }).then((response) => {
        if(response.data.status) {
          var new_unended_visits = [];
          for(var i = 0; i < this.unended_visits.length; i++) {
            if(this.unended_visits[i].id != id) {
              new_unended_visits.push(this.unended_visits[i])
            }
          }
          this.unended_visits = new_unended_visits;
          localStorage.setItem("fve_unended_visits", JSON.stringify(this.unended_visits));
          this.snackbartext = "Besuch erfolgreich beendet";
          this.snackbar = true;
        } else {
          this.snackbartext = "Beenden hat leider nicht funktioniert";
          this.snackbar = true;
          console.log(response);
        }
        this.loading = false
      }).catch((error) => {
        console.error(error);
        this.snackbartext = "Beenden hat leider nicht funktioniert";
        this.snackbar = true;
        this.loading = false
      });
    },
    autofill_form() {
      let data = localStorage.getItem("fve_guest_register_data");
      if(data && data != "") {
        let data_obj = JSON.parse(data);
        if(data_obj.area) {
          this.select = data_obj.area;
        }
        if(data_obj.fname) {
          this.vorname = data_obj.fname;
        }
        if(data_obj.sname) {
          this.nachname = data_obj.sname;
        }
        if(data_obj.telephone) {
          this.telefonnummer = data_obj.telephone;
        }
        if(data_obj.persons) {
          this.anzahlPersonen = data_obj.persons;
        }
        this.checkbox = true;
      }
    }
  },
  mounted() {
    this.autofill_form();
    this.handle_unended_visits();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .form_wrapper {
    max-width: 580px;
    width: 100%;
    padding: 20px;
    padding-bottom: 120px;
    box-sizing: border-box;
    margin: auto;
  }
  img {
    display: block;
    max-width: 80px;
    width: 100%;
    margin: auto
  }
  h3 {
    text-align: center;
    margin-bottom: 30px;
    margin-top: 15px;
  }
  .submit_holder {
    position: fixed;
    width: 100%;
    left: 0px;
    bottom: 0px;
    background: rgba(255,255,255,0.8);
    height: 70px;
    text-align: center;
    padding: 0px 20px;
    box-shadow: 0px 1px 5px 0px rgba(0,0,0,.5);
  }
  .submit_button {
    margin-top: 17px;
  }
  .submit_button_wrapper {
    max-width: 540px;
    margin:auto;
  }
  ul {
    padding: 0px !important;
    list-style: none;
  }
  .row {
    margin: 0px;
  }
  ul li {
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0,0,0,.5);
  }
  ul li span {
    line-height: 36px;
    font-size: 16px;
  }
  .unended_visits {
    margin-top: 30px;
    margin-bottom: 50px;
  }
  h4 {
    font-size: 18px;
  }
  @media only screen and (max-width: 440px) {
    ul li span {
      display: block;
      width: 100%;
    }
  }
</style>
